export const shortUrlEndpointIds = {
    CREATE_SHORT_URL: 'CREATE_SHORT_URL',
    GET_SHORT_URL_STATS: 'GET_SHORT_URL_STATS',
    UPDATE_SHORT_URL: 'UPDATE_SHORT_URL',
    LIST_SHORT_URLS: 'LIST_SHORT_URLS',
    DELETE_SHORT_URL: 'DELETE_SHORT_URL',
};
